  import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  Form,
  Input,
  InputNumber,
  Button,
  Popover,
  Select,
  Icon,
} from "antd";
import axios from "axios";
import "./styles.css";

const convertBasedOnLevel = require("../utilities/calc-stats");

const reactStringReplace = require("react-string-replace");

const Option = Select.Option;

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  componentDidMount() {
    if (this.props.editable) {
      document.addEventListener("click", this.handleClickOutside, true);
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      document.removeEventListener("click", this.handleClickOutside, true);
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  handleClickOutside = (e) => {
    const { editing } = this.state;
    if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
      this.save();
    }
  };

  save = () => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  checkLevel = (rule, value, callback) => {
    if (value > 0) {
      callback();
      return;
    }
    callback("Level must be >0!");
  };

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      ...restProps
    } = this.props;
    return (
      <td ref={(node) => (this.cell = node)} {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {(form) => {
              this.form = form;
              return editing ? (
                <FormItem style={{ margin: 0 }}>
                  {form.getFieldDecorator(dataIndex, {
                    rules: [
                      {
                        validator: this.checkLevel,
                        type: "number",
                        required: true,
                      },
                    ],
                    initialValue: record[dataIndex],
                  })(
                    <Input
                      ref={(node) => (this.input = node)}
                      onPressEnter={this.save}
                    />
                  )}
                </FormItem>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  onClick={this.toggleEdit}
                >
                  {restProps.children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          restProps.children
        )}
      </td>
    );
  }
}

class AllCatsTable extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      // {
      //   title: "No.",
      //   width: 70,
      //   align: "center",
      //   dataIndex: "number",
      //   key: "number",
      //   sorter: (a, b) => {
      //     var nameA = a.key.toUpperCase();
      //     var nameB = b.key.toUpperCase();
      //     if (nameA < nameB) {
      //       return -1;
      //     }
      //     if (nameA > nameB) {
      //       return 1;
      //     }
      //     return 0;
      //   }
      // },

      {
        title: (
          <div>
            <Popover
              trigger="click"
              placement="topLeft"
              content={
                <div onClick={(e) => e.stopPropagation()}>
                  Cat Levels:
                  {"  "}
                  <InputNumber
                    min={1}
                    max={999}
                    defaultValue={30}
                    size="small"
                    onChange={this.onInputNumberChange.bind(this)}
                  />
                  <br />
                  Version: &nbsp; &nbsp;
                  <Select
                    defaultValue="All"
                    style={{ width: 98, padding: "5px" }}
                    size="small"
                    onChange={this.onVersionChange.bind(this)}
                  >
                    <Option value="All">All</Option>
                    <Option value="BCEN">BCEN</Option>
                    <Option value="BCJP">BCJP</Option>
                  </Select>
                </div>
              }
            >
              <Button style={{ padding: "0px 12px" }}>
                <Icon type="setting" />
              </Button>
            </Popover>
          </div>
        ),
        width: 57,
        dataIndex: "img",
        key: "img",
        fixed: "left",
        render: (text, record) => (
          // <a
          //   href={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          //   // target="_blank"
          // >
          <Link
            to={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          >
            <img
              src={
                "https://onestoppress.com/images/" +
                record.number +
                "_square.png"
              }
              alt={record.name}
            />
          </Link>
          // </a>
        ),
      },
      {
        title: "Name",
        width: 120,
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          // <a
          //   href={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          //   // target="_blank"
          // >
          <Link
            to={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          >
            {record.name}
          </Link>
          // </a>
        ),
        // fixed: "left",
      },
      {
        title: "Form",
        width: 100,
        dataIndex: "form",
        key: "form",
        render: (text, record) => (
          <Button
            // type="primary"
            style={{
              display: "block",
              width: "66px",
              paddingLeft: "8px",
              paddingRight: "8px",
            }}
            onClick={this.onChangeFormClick.bind(
              this,
              record.number,
              record.level2,
              record.key
            )}
          >
            {text}
          </Button>
        ),
        filters: [
          {
            text: "Normal",
            value: "Normal",
          },
          {
            text: "Evolved",
            value: "Evolved",
          },
          {
            text: "True",
            value: "True",
          },
          {
            text: "Ultra",
            value: "Ultra",
          },
        ],
        onFilter: (value, record) => record.form.indexOf(value) === 0,
      },
      {
        title: "Rarity",
        dataIndex: "rarity",
        key: "rarity",
        width: 100,
        filters: [
          {
            text: "Basic",
            value: "Basic",
          },
          {
            text: "Special",
            value: "Special",
          },
          {
            text: "Rare",
            value: "Rare",
          },
          {
            text: "Super",
            value: "Super",
          },
          {
            text: "Uber",
            value: "Uber",
          },
          {
            text: "Legendary",
            value: "Legendary",
          },
        ],
        onFilter: (value, record) => record.rarity.indexOf(value) === 0,
        // sorter: (a, b) => {
        //   var nameA = a.key.toUpperCase();
        //   var nameB = b.key.toUpperCase();
        //   if (nameA < nameB) {
        //     return -1;
        //   }
        //   if (nameA > nameB) {
        //     return 1;
        //   }
        //   return 0;
        // }
      },
      // {
      //   title: "Level",
      //   dataIndex: "level",
      //   key: "level",
      //   width: 100,
      //   align: "center"
      // },
      {
        title: "Level",
        dataIndex: "level2",
        key: "level2",
        width: 100,
        align: "center",
        editable: true,
        // filterDropdown: () => <Input />,
        render(text) {
          return (
            <div style={{ textAlign: "center" }}>
              <span
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "4px",
                  padding: "4px 11px",
                  display: "block",
                }}
              >
                {text}
              </span>
            </div>
          );
        },
      },
      {
        title: "Health",
        dataIndex: "health2",
        key: "health2",
        width: 90,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.health
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.health
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.health;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "Damage",
        dataIndex: "damage2",
        key: "damage2",
        width: 100,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.damage
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.damage
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.damage;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
              {/* {typeof isCrazed} */}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "Range",
        dataIndex: "range",
        key: "range",
        width: 90,
        align: "center",
        sorter: (a, b) => a.range - b.range,
      },
      {
        title: "KB",
        dataIndex: "kb",
        key: "kb",
        width: 60,
        align: "center",
        sorter: (a, b) => a.kb - b.kb,
      },
      {
        title: "Speed",
        dataIndex: "speed",
        key: "speed",
        width: 90,
        align: "center",
        sorter: (a, b) => a.speed - b.speed,
      },
      {
        title: "DPS",
        dataIndex: "dps2",
        key: "dps2",
        width: 70,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.dps
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.dps
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.dps;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
              {/* {typeof isCrazed} */}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "Target",
        dataIndex: "target",
        key: "target",
        width: 90,
        align: "center",
        filters: [
          {
            text: "Single",
            value: "Single",
          },
          {
            text: "Area",
            value: "Area",
          },
        ],
        onFilter: (value, record) => record.target.indexOf(value) === 0,
        // sorter: (a, b) => {
        //   var nameA = a.key.toUpperCase();
        //   var nameB = b.key.toUpperCase();
        //   if (nameA < nameB) {
        //     return -1;
        //   }
        //   if (nameA > nameB) {
        //     return 1;
        //   }
        //   return 0;
        // }
      },
      {
        title: "Time Between Attacks",
        dataIndex: "tba",
        key: "tba",
        width: 130,
        align: "center",
        sorter: (a, b) => a.tba - b.tba,
      },
      {
        title: "Atk. Animation",
        dataIndex: "anim",
        key: "anim",
        width: 110,
        align: "center",
        sorter: (a, b) => a.anim - b.anim,
      },
      {
        title: "Recharging Time",
        dataIndex: "spawn",
        key: "spawn",
        width: 96,
        align: "center",
        sorter: (a, b) => a.spawn - b.spawn,
      },
      {
        title: "Cost",
        dataIndex: "cost",
        key: "cost",
        width: 70,
        align: "center",
        sorter: (a, b) => a.cost - b.cost,
      },
      {
        title: "Enemy Types",
        dataIndex: "enemy",
        key: "enemy",
        width: 130,
        align: "center",
        filters: [
          {
            text: "Red",
            value: "red",
          },
          {
            text: "Floating",
            value: "floating",
          },
          {
            text: "Black",
            value: "black",
          },
          {
            text: "Metal",
            value: "metal",
          },
          {
            text: "Angel",
            value: "angel",
          },
          {
            text: "Alien",
            value: "alien",
          },
          {
            text: "Zombie",
            value: "zombie",
          },
          {
            text: "Relic",
            value: "relic",
          },
          {
            text: "Aku",
            value: "aku",
          },
          {
            text: "White",
            value: "white",
          },
        ],
        onFilter: function (value, record) {
          return record.ability.includes(
            record.ability.match(new RegExp(value)) !== null
              ? record.ability.match(new RegExp(value))[0]
              : "-1"
          );
        },
        render(text, record) {
          const enemylist = [
            "Red",
            "Floating",
            "Black",
            "Metal",
            "Angel",
            "Alien",
            "Zombie",
            "Relic",
            "Aku",
            "White",
          ];
          var enemy = "";
          const ability = record.ability;

          for (var i = 0; i < enemylist.length; i++) {
            if (ability.includes(enemylist[i].toLowerCase())) {
              if (enemy.length > 0) {
                enemy += ", " + enemylist[i];
              } else {
                enemy = enemylist[i];
              }
            }
          }

          return <div>{enemy}</div>;
        },
      },
      {
        title: "Ability",
        dataIndex: "ability2",
        key: "ability2",

        filters: [
          {
            text: "Attacks Only",
            value: "Attacks only",
          },
          {
            text: "Barrier Breaker",
            value: "Barrier Breaker",
          },
          {
            text: "Base Destroyer",
            value: "Base Destroyer",
          },
          {
            text: "Behemoth Slayer",
            value: "Behemoth Slayer",
          },
          {
            text: "Colossus Slayer",
            value: "Colossus Slayer",
          },
          {
            text: "Critical",
            value: "Critical",
          },
          {
            text: "Curse",
            value: "to curse",
          },
          {
            text: "Dodge",
            value: "Dodge",
          },
          {
            text: "Eva Angel Killer",
            value: "Eva Angel Killer",
          },
          {
            text: "Evade Surge",
            value: "Not(.*Surge)",
          },
          {
            text: "Extra Money",
            value: "money gained",
          },
          {
            text: "Freeze",
            value: "to freeze",
          },
          {
            text: "Immune to Curse",
            value: "Not(.*Curse)",
          },
          {
            text: "Immune to Toxic",
            value: "Not(.*Toxic)",
          },
          {
            text: "Insane Damage",
            value: "Insane Damage",
          },
          {
            text: "Insanely Tough",
            value: "Insanely Tough",
          },
          {
            text: "Knockback",
            value: "of knockback",
          },
          {
            text: "Long Distance",
            value: "Long Distance",
          },
          {
            text: "Massive Damage",
            value: "Massive Damage",
          },
          {
            text: "Is Metal",
            value: "Only takes 1",
          },
          {
            text: "Mini-Wave",
            value: "Mini-Wave",
          },
          {
            text: "Multi-hit Attack",
            value: "Multi-hit",
          },
          {
            text: "Omni Strike",
            value: "Omni Strike",
          },
          {
            text: "Resist Freeze",
            value: "Not(.*Freeze)",
          },
          {
            text: "Resist Knockback",
            value: "Not(.*Knockback)",
          },
          {
            text: "Resist Slow",
            value: "Not(.*Slow)",
          },
          {
            text: "Resist Weaken",
            value: "Not(.*Weaken)",
          },
          {
            text: "Resistant",
            value: "Resistant",
          },
          {
            text: "Savage Blow",
            value: "Savage Blow",
          },
          {
            text: "Shield Piercing",
            value: "Shield Piercing",
          },
          {
            text: "Slow",
            value: "to slow",
          },
          {
            text: "Strengthen",
            value: "Strengthen",
          },
          {
            text: "Strong",
            value: "Strong",
          },
          {
            text: "Surge Attacks",
            value: "Surge Attacks",
          },
          {
            text: "Survive",
            value: "Survive",
          },
          {
            text: "Unharmed by Waves",
            value: "Not(.*Wave)",
          },
          {
            text: "Warp Blocker",
            value: "Not(.*Warp)",
          },
          {
            text: "Wave Attack",
            value: "Wave attack",
          },
          {
            text: "Wave Shield",
            value: "Wave Shield",
          },
          {
            text: "Weaken",
            value: "to weaken",
          },
          {
            text: "Zombie Killer",
            value: "Zombie Killer",
          },
          {
            text: "Conjure",
            value: "Conjure",
          },
          {
            text: "Sage Slayer",
            value: "Sage Slayer",
          },
        ],
        onFilter: function (value, record) {
          return record.ability.match(new RegExp(value)) !== null;
        },
        render(text, record) {
          const abilitycopy = record.ability;
          const formattedb = reactStringReplace(
            abilitycopy,
            /b1(.+?)b2/g,
            (match, i) => <b key={"b" + i}>{match}</b>
          );
          const formattedu = reactStringReplace(
            formattedb,
            /u1(.+?)u2/g,
            (match, i) => <u key={"u" + i}>{match}</u>
          );
          return {
            props: {
              style: { whiteSpace: "pre-wrap" },
            },
            children: <div>{formattedu}</div>,
          };
        },
      },
    ];

    this.state = {
      dataSource: [],
      catLevels: "",
    };
  }

  // handleSearch = (selectedKeys, confirm) => () => {
  //   confirm();
  //   this.setState({ searchText: selectedKeys[0] });
  // };

  // handleReset = clearFilters => () => {
  //   clearFilters();
  //   this.setState({ searchText: "" });
  // };

  componentDidMount() {
    axios
      .get("https://onestoppress.com/api/allcats")
      .then((res) => {
        let dataSource = res.data.sampledata.map(function (cat, index) {
          var o = Object.assign({}, cat);
          o.key = index;
          o.level2 = 30;
          // if (o.ability === null) {
          //   o.ability = " ";
          // }
          return o;
        });
        // let dataSource = res.data.sampledata.map;

        this.setState({ dataSource: dataSource }, function () {
          // console.log("state: ", this.state.dataSource);
        });
      })
      .catch((err) => console.log("err: ", err));
  }

  onChangeFormClick = (number, level2, key) => {
    // Replace cat with its next form
    // console.log(number, level2);
    // console.log(key);
    axios
      .post("https://onestoppress.com/api/nextcat", {
        cat_no_req: number,
      })
      .then((res) => {
        // console.log(number);
        let nextForm = res.data.sampledata;
        nextForm.level2 = level2;
        nextForm.key = key;

        var o = this.state.dataSource.slice();
        // var catindex = o.indexOf(record);
        // o[catindex] = nextForm;
        o[key] = nextForm;

        this.setState({ dataSource: o });
      })
      .catch((err) => console.log("err: ", err));
  };

  onInputNumberChange(value) {
    if (value > 0 && value < 1000) {
      let dataSource = this.state.dataSource.map(function (cat) {
        cat.level2 = value;
        return cat;
      });

      this.setState({
        catLevels: value,
        dataSource: dataSource,
      });
    }
  }

  onVersionChange(version) {
    const catLevels = this.state.catLevels === "" ? 30 : this.state.catLevels;
    const ver = version === "All" ? "" : version === "BCEN" ? "jp" : "en";

    axios
      .get("https://onestoppress.com/api/allcats")
      .then((res) => {
        let dataSource = res.data.sampledata
          .filter((cat) => cat.version_available !== ver)
          .map(function (cat, index) {
            var o = Object.assign({}, cat);
            o.key = index;
            o.level2 = catLevels;
            return o;
          });

        this.setState({ dataSource: dataSource }, function () {
          // console.log("state: ", this.state.dataSource);
        });
      })
      .catch((err) => console.log("err: ", err));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.catLevel !== nextProps.catLevel) {
      if (nextProps.catLevel > 0 && nextProps.catLevel < 1000) {
        let dataSource = this.state.dataSource.map(function (cat) {
          cat.level2 = nextProps.catLevel;
          return cat;
        });

        this.setState({ dataSource: dataSource });
      }
    }
  }

  handleSave = (row) => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    this.setState({ dataSource: newData });
  };

  // onChange(filters, sorter) {
  //   console.log("params", filters, sorter);
  // }

  // onLevelChange(value) {
  //   console.log("changed", value);
  // }

  render() {
    const { dataSource } = this.state;
    const innerHeight = this.props.viewportHeight;

    const components = {
      body: {
        cell: EditableCell,
        row: EditableFormRow,
      },
    };
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <Table
        columns={columns}
        components={components}
        rowClassName={() => "editable-row"}
        dataSource={dataSource}
        scroll={{ x: 2000, y: innerHeight }}
        // onChange={this.onChange.bind(this)}
        size="small"
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 100,
          pageSizeOptions: ["25", "50", "100", "1500"],
        }}
        locale={{
          emptyText: (
            <div>
              Loading in progress...
              <p></p>
              View all the cats in The Battle Cats here! Filter them by their
              form, rarity, target, enemies and abilities, or sort them by their
              health, damage, and more to compare them easily.
              <p></p>
              Find out which the best battle cats are for you now!
            </div>
          ),
        }}
      />
    );
  }
}

export default AllCatsTable;



// WEBPACK FOOTER //
// ./src/components/table/AllCatsTable.js